import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface authInfo {
  accessToken: string;
  fullName: string;
  role: string;
}

interface AuthState {
  isAuthenticated: boolean;
  authInfo: authInfo | null;
}

const initialState: AuthState = {
  isAuthenticated: false,
  authInfo: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, action: PayloadAction<authInfo>) {
      state.isAuthenticated = true;
      state.authInfo = action.payload;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.authInfo = null;
      localStorage.removeItem('authInfo');
    },
  },
});

export const { login, logout } = authSlice.actions;

export default authSlice.reducer;
